import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Text, View } from '@olxbr/design-system'
import MailCheck from '../../atoms/MailCheck'

const Content = styled(View)`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Title = styled(Text)`
  text-align: center;
  margin-top: var(--spacing-1);
  font-size: 16px;
`

const Email = styled(Text)`
  text-align: center;
  font-weight: bold;
  font-size: 16px;
  margin-bottom: var(--spacing-3);
`

const Description = styled(Text)`
  text-align: center;
  margin-top: 24px;
  font-size: 16px;
`

const passwordRecoveryRequested = props => {
  const { email } = props
  return (
    <Content>
      <MailCheck />
      <Title>Enviamos um e-mail para</Title>
      <Email fontWeight={700}>{email}</Email>
      <Description>Redefine sua senha para reforçar a proteção da sua conta.</Description>
    </Content>
  )
}

passwordRecoveryRequested.propTypes = {
  email: PropTypes.string.isRequired,
}

export default passwordRecoveryRequested
